//  Copyright (c) 2025 coze-dev
//  SPDX-License-Identifier: MIT

export const LINT_REFRESH_USER_EVENT = 'sdk.lint.refresh';
export const DEFAULT_SYNTAX_THEME = 'one-dark-pro';
